module.exports = __webpack_public_path__ + "static/media/di-raggio.23c77477.jpg";